import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import Modal from '@/components/common/Modal/Modal';
import BetHistoryTab from './tabs/BetHistoryTab';
import TransactionsTab from './tabs/TransactionsTab';
import styles from './BetHistoryModal.module.css';

/**
 * BetHistoryModal Component
 * Modal for bet history and transactions with tabs
 * Opens via route: /modal?mode=bethistory
 * Full screen on mobile, modal on desktop
 */
const BetHistoryModal = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const mode = searchParams.get('mode');
  const [isOpen, setIsOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('bets'); // 'bets' | 'transactions'

  useEffect(() => {
    // Check if modal should be open based on query params
    if (location.pathname === '/modal' && mode === 'bethistory') {
      setIsOpen(true);
      // Set initial tab from query params if provided
      const tab = searchParams.get('tab');
      if (tab === 'transactions') {
        setActiveTab('transactions');
      } else {
        setActiveTab('bets');
      }
    } else {
      setIsOpen(false);
    }
  }, [location.pathname, mode, searchParams]);

  const handleClose = () => {
    setIsOpen(false);
    // Remove mode query param and navigate to home
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.delete('mode');
    newSearchParams.delete('tab');
    navigate(`/?${newSearchParams.toString()}`, { replace: true });
  };

  const switchTab = (tab) => {
    setActiveTab(tab);
    // Update query param
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.set('mode', 'bethistory');
    newSearchParams.set('tab', tab);
    navigate(`/modal?${newSearchParams.toString()}`, { replace: true });
  };

  const getModalTitle = () => {
    switch (activeTab) {
      case 'bets':
        return 'Bet History';
      case 'transactions':
        return 'Transactions';
      default:
        return 'Bet History';
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      size="xl"
      title={getModalTitle()}
      showCloseButton={true}
      className={styles.modal}
    >
      <div className={styles.modalBody}>
        {/* Tabs */}
        <div style={{marginTop:'10px'}} className={styles.tabs}>
          <button
            className={`${styles.tab} ${activeTab === 'bets' ? styles.tabActive : ''}`}
            onClick={() => switchTab('bets')}
          >
            Bet History
          </button>
          <button
            className={`${styles.tab} ${activeTab === 'transactions' ? styles.tabActive : ''}`}
            onClick={() => switchTab('transactions')}
          >
            Transactions
          </button>
        </div>

        {/* Tab Content */}
        <div className={styles.tabContent}>
          {activeTab === 'bets' && <BetHistoryTab />}
          {activeTab === 'transactions' && <TransactionsTab />}
        </div>
      </div>
    </Modal>
  );
};

export default BetHistoryModal;
